import React from 'react';
import PropTypes from 'prop-types';
import BEM from '../bem';
import mobxInjectSelect from '../utils/mobxInjectSelect';
import Modal from './Modal';

const classes = BEM.with('DeleteTemplateModal');

const DeleteTemplateModal = ({ closeModal, deleteTemplate, deleteTemplates, isOpen, options }) => {
  const { reloadTemplates, selected } = options;

  const _deleteSelected = async (selected) => {
    if (selected.length === 1) {
      await deleteTemplate(selected[0]);
    } else {
      await deleteTemplates(selected);
    }
    reloadTemplates();
    closeModal();
  };

  return (
    <Modal
      bodyClass={classes('body')}
      closeClass={classes('close-button')}
      footerClass={classes('footer')}
      header={'Confirm Delete'}
      headerClass={classes('header')}
      isOpen={isOpen}
      size={'medium'}
      footerPrimaryActions={
        <button
          type="button"
          className={classes('delete-btn')}
          onClick={() => _deleteSelected(selected)}
        >
          DELETE {selected.length > 1 && `(${selected.length})`}
        </button>
      }
      footerSecondaryActions={
        <button type="button" onClick={closeModal} className={classes('cancel-btn')}>
          CANCEL
        </button>
      }
      className={classes()}
      onRequestClose={closeModal}
    >
      <div className={classes('info')}>
        Are you sure you want to delete the Message Template
        {selected.length > 1 && 's'}?
      </div>
    </Modal>
  );
};

DeleteTemplateModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deleteTemplate: PropTypes.func.isRequired,
  deleteTemplates: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  options: PropTypes.shape({
    reloadTemplates: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default mobxInjectSelect({
  patientAdminStore: ['deleteTemplates', 'deleteTemplate'],
})(DeleteTemplateModal);
